import type { OrderInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

import {
  ORDER_FIELDS,
  ORDER_PRODUCTS_FIELDS,
  ORDER_SHOP_FIELDS,
  ORDER_TOTALS_FIELDS
} from '@@partner:graphql/shortcuts'

export interface UpdateOrderInfoMutationVariableData
  extends Record<string, any> {
  recipientInfo?: {
    firstName: string
    lastName: string
  }
}

export interface UpdateOrderInfoMutation {
  updated: OrderInfo
}
export interface UpdateOrderInfoMutationVariables {
  order_id: GQL_ID
  data: UpdateOrderInfoMutationVariableData // TODO: make better type
}

export const GQL_MUTATION_UPDATE_ORDER_INFO = gql`
  mutation($order_id: ID!, $data: OrderInfoInput!) {
    updated: updateOrderInfo(order_id: $order_id, data: $data) {
      ${ORDER_FIELDS}
      ${ORDER_SHOP_FIELDS}
      ${ORDER_PRODUCTS_FIELDS}
      ${ORDER_TOTALS_FIELDS}
    }
  }
`

export const useUpdateOrderInfo = () =>
  useMutation<UpdateOrderInfoMutation, UpdateOrderInfoMutationVariables>(
    GQL_MUTATION_UPDATE_ORDER_INFO
  )
